import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Sentry } from '@org/ui';

// The root is a thin, UNAUTHENTICATED shell: public pages (the /journal
// landing for Journal2Empower readers) render directly under it, while the
// whole student app lives under the pathless `_app` layout, which carries the
// Auth0 guard, the sidebar, and the top navbar. Student URLs are unchanged.
function RouteErrorComponent({ error }: { error: Error }) {
  Sentry.captureException(error, { tags: { source: 'tanstack-router-root' } });
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <h2>This page failed to load</h2>
      <p>Please refresh to try again.</p>
    </div>
  );
}

export const Route = createRootRoute({
  component: Outlet,
  errorComponent: RouteErrorComponent,
});
